import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mock.js';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_f558ecc9-3d5c-464e-b77a-acd9d9c402ff/artifacts/abhdxz9f_Sparecraft_Logo_no%20bg.png" 
              alt="Sparecraft Solutions" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 mb-4">
              Retail and wholesale supply of JCB backhoe loader and forklift spare parts.
            </p>
            <div className="flex flex-col space-y-2 text-sm">
              <div className="flex items-center">
                <span className="font-semibold text-white">GST:</span>
                <span className="ml-2">{businessInfo.gst}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-[#FF6B7A] transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#FF6B7A] transition-colors">About Us</Link></li>
              <li><Link to="/products" className="hover:text-[#FF6B7A] transition-colors">Products</Link></li>
              <li><Link to="/wholesale" className="hover:text-[#FF6B7A] transition-colors">Wholesale Enquiry</Link></li>
              <li><Link to="/contact" className="hover:text-[#FF6B7A] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Products</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-[#00C9FF] transition-colors">JCB Spare Parts</li>
              <li className="hover:text-[#00C9FF] transition-colors">Forklift Spare Parts</li>
              <li className="hover:text-[#00C9FF] transition-colors">Engine Components</li>
              <li className="hover:text-[#00C9FF] transition-colors">Hydraulic Parts</li>
              <li className="hover:text-[#00C9FF] transition-colors">Electrical Parts</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 flex-shrink-0 text-[#00C9FF]" />
                <span>{businessInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 text-[#00C9FF]" />
                <a href={`tel:${businessInfo.phone}`} className="hover:text-[#FF6B7A] transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-[#00C9FF]" />
                <a href={`mailto:${businessInfo.email}`} className="hover:text-[#FF6B7A] transition-colors">
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start">
                <Clock className="h-5 w-5 mr-2 flex-shrink-0 text-[#00C9FF]" />
                <span>{businessInfo.businessHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} {businessInfo.name}. All rights reserved.</p>
          <p className="mt-2">{businessInfo.region}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
